import { render, staticRenderFns } from "./randotin_jump.config.vue?vue&type=template&id=30c7ec9e"
import script from "./randotin_jump.config.vue?vue&type=script&lang=js"
export * from "./randotin_jump.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports